import type { CustomerRecord } from '@/domain/types';
import ConversationTimelineEntry from '@/components/ConversationTimelineEntry';

interface Props {
  customer: CustomerRecord;
  className?: string;
}

/**
 * Single source of truth for a customer's conversation thread: the heading,
 * the empty-state, and the timeline entries. Deliberately excludes the live
 * call / AI banners so each parent (the customer record, an upcoming work
 * modal) can position those independently.
 */
export default function ConversationThread({ customer, className }: Props) {
  return (
    <div className={className}>
      <h2 className="label-small-caps text-gold mb-4">Conversation</h2>
      {customer.conversation.length === 0 ? (
        <p className="font-serif text-cream-soft">No messages yet.</p>
      ) : null}
      {customer.conversation.map((entry) => (
        <ConversationTimelineEntry key={entry.id} entry={entry} customer={customer} />
      ))}
    </div>
  );
}
